<template>
<div class="chapter">
<div class="inner_page">
<div class="contentsPage" id="d7e159">
<h3 class="toc" id="d7e160">Contents</h3>
<p class="contentsDiv">
<a href="#/Krae_9781440501029_epub_int#int">Introduction</a>
<br/>
</p>
<h4>Part I</h4>
<p class="contentsDiv">
<a href="#/Krae_9781440501029_epub_p1#p1">The ABCs of Reverse Mortgages</a>
<br/>
</p>
<p class="contentsDiv">
<a href="#/Krae_9781440501029_epub_c1#c1">CHAPTER 1: The Reverse Mortgage Story</a>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c2#c2" title="Link target outside of Sample">CHAPTER 2: Reverse Mortgage Basics</span>
<br/>
</p>
<h4>Part II</h4>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_p2#p2" title="Link target outside of Sample">Considering the Options</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c3#c3" title="Link target outside of Sample">CHAPTER 3: Home Equity Conversion Mortgages</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c4#c4" title="Link target outside of Sample">CHAPTER 4: Fannie Mae Home Keeper Mortgage</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c5#c5" title="Link target outside of Sample">CHAPTER 5: Financial Freedom Cash Account Advantage Plan</span>
<br/>
</p>
<h4>Part III</h4>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_p3#p3" title="Link target outside of Sample">Personal Planning</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c6#c6" title="Link target outside of Sample">CHAPTER 6: Health Care, Long-Term Care, and Government Benefits</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c7#c7" title="Link target outside of Sample">CHAPTER 7: Alternatives to a Reverse Mortgage</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c8#c8" title="Link target outside of Sample">CHAPTER 8: What Is a Reverse Mortgage Worth to Me?</span>
<br/>
</p>
<h4>Part IV</h4>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_p4#p4" title="Link target outside of Sample">Making It Happen</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c9#c9" title="Link target outside of Sample">CHAPTER 9: The Reverse Mortgage Team</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c10#c10" title="Link target outside of Sample">CHAPTER 10: Choosing the Right Loan and Other Decisions</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c11#c11" title="Link target outside of Sample">CHAPTER 11: Demystifying the Approval Process</span>
<br/>
</p>
<h4>Part V</h4>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_p5#p5" title="Link target outside of Sample">Other Important Considerations</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c12#c12" title="Link target outside of Sample">CHAPTER 12: Closing and Managing a Reverse Mortgage</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c13#c13" title="Link target outside of Sample">CHAPTER 13: Special Circumstances and Considerations</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c14#c14" title="Link target outside of Sample">APPENDIX A: Loan Comparison Worksheets</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c15#c15" title="Link target outside of Sample">APPENDIX B: Loan-Specific Worksheets</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c16#c16" title="Link target outside of Sample">APPENDIX C: Resources</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c17#c17" title="Link target outside of Sample">APPENDIX D: Glossary</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/Krae_9781440501029_epub_c19#c19" title="Link target outside of Sample">About the Authors</span>
<br/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Krae_9781440501029_epub_toc.vue?7163be2c